// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UwV0","controls":"styles_controls__1J_pw","charLimit":"styles_charLimit__3DmyP","input":"styles_input__3nqWs","send":"styles_send__2VWv1"};